import { createSlice } from "@reduxjs/toolkit";
import { addRoleAPI } from "../../api/role";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
}; 

const addRoleSlice = createSlice({
  name: "addRole",
  initialState: data,
  reducers: {
   addRoleSlice(state) {
      state.isLoading = true;
    },
   addRoleSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    addRoleSliceFailure(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
   addRoleSliceReset(state) {
      state.isLoading = false;
      state.data = null;
    },
  },
});
export const addRoleHandler = (data:any) => async (dispatch: any) => {
  try {
    dispatch(addRoleAction.addRoleSlice());
    const response: any = await addRoleAPI(data);
    
    dispatch(addRoleAction.addRoleSliceSuccess(response));
  } catch (e: any) {
    dispatch(addRoleAction.addRoleSliceFailure(e?.response?.data));
  }
};
export default addRoleSlice.reducer;
export const addRoleAction = addRoleSlice.actions;
